import React from "react"
import { ResponsiveBar } from "@nivo/bar"
import ChartCard from "@react/projects/chantiers_dashboard/components/ChartCard"
import { PALETTE, NIVO_THEME, formatShort } from "@react/projects/chantiers_dashboard/components/palette"

const ExpiryChart = ({ data, currency }) => {
  const rows = (data || []).map((row) => ({ quarter: row.label, value: row.value / 100, count: row.count }))
  const money = (value) =>
    new Intl.NumberFormat(I18n.locale || "fr", {
      style: "currency", currency: currency || "EUR", maximumFractionDigits: 0,
    }).format(value)

  return (
    <ChartCard
      icon     = "hourglass-half"
      title    = {I18n.t("contracts_dashboard.charts.expiry")}
      subtitle = {I18n.t("contracts_dashboard.charts.expiry_hint")}
      height   = {280}
      empty    = {rows.length === 0 ? I18n.t("contracts_dashboard.charts.no_expiry") : null}
    >
      <ResponsiveBar
        data         = {rows}
        keys         = {["value"]}
        indexBy      = "quarter"
        margin       = {{ top: 18, right: 24, bottom: 44, left: 74 }}
        padding      = {rows.length <= 2 ? 0.72 : 0.35}
        colors       = {[PALETTE.amber]}
        borderRadius = {3}
        enableLabel  = {false}
        axisLeft     = {{ tickSize: 0, tickPadding: 8, format: (v) => formatShort(v * 100) }}
        axisBottom   = {{ tickSize: 0, tickPadding: 10 }}
        theme        = {NIVO_THEME}
        tooltip      = {({ value, indexValue, data: row }) => (
          <div style={{ background: "#0f172a", color: "#fff", padding: "7px 11px", fontSize: 11, borderRadius: 6 }}>
            <strong>{indexValue}</strong> · {money(value)}
            <div style={{ opacity: 0.75 }}>
              {I18n.t("contracts_dashboard.charts.contracts_count", { count: row.count })}
            </div>
          </div>
        )}
      />
    </ChartCard>
  )
}

export default ExpiryChart
